/**
 * Resolves the QR-friendly `/:gameId/play/:code/new` URL into a stable
 * per-device URL `/:gameId/play/:code/:uid`. The uid comes from
 * `getOrCreateLocalUid()` so the same browser keeps the same identity
 * across rejoins (closing the tab and re-scanning the QR is a reconnect,
 * not a duplicate join).
 */

import { Box, Loader, Stack, Text } from '@mantine/core'
import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { getOrCreateLocalUid } from '../lobby/profile'

export function JoinRedirect() {
  const { gameId, code } = useParams<{ gameId: string; code: string }>()

  // Trigger uid generation on mount even though the redirect below also
  // calls it — keeps timing predictable across React 18 strict mode.
  useEffect( () => {
    getOrCreateLocalUid()
  }, [] )

  if ( !gameId || !code ) {
    return (
      <Box
        style={ {
          minHeight: '100vh',
          background: '#0B0F1A',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        } }
      >
        <Stack
          align="center"
          gap="md"
        >
          <Loader color="yellow" />
          <Text c="dimmed">Joining…</Text>
        </Stack>
      </Box>
    )
  }

  const uid = getOrCreateLocalUid()
  return (
    <Navigate
      to={ `/games/${ gameId }/play/${ code }/${ uid }` }
      replace
    />
  )
}
